import './index.scss';
import PropTypes from 'prop-types';
import RadioButton from '../../shared/components/radio-button/radio-button';
import React from 'react';
import { sortFieldName } from './atpReallocationData';

const AtpReallocationTable = props => (

    <table>
        <thead>
            <tr>
                {props.type.map( ( i, index ) => <th key={i}>{index + 1}</th> )}
                <th>{' '}</th>
            </tr>
        </thead>
        <tbody>
            {props.type.map( i => (

                <tr key={i}>
                    {props.type.map( ( j, jindex ) => (

                        <td key={`${i}-${jindex}`}>
                            <RadioButton
                                id={`${i}_${jindex}`}
                                value={`${i}_${jindex}`}
                                isSelected={Boolean(
                                    props.data.length > 0 &&
                                    props.data[0] &&
                                    props.data[0][sortFieldName( jindex )] &&
                                        i === props.data[0][sortFieldName( jindex )].trim()
                                )}
                                changed={() => props.onChange( props.name, i, jindex )}
                            />
                        </td>

                    ) )}
                    <td>
                        {i}
                    </td>
                </tr>

            ) )}
        </tbody>
    </table>

);

AtpReallocationTable.propTypes = {
    name: PropTypes.string,
    type: PropTypes.array,
    data: PropTypes.array,
    onChange: PropTypes.func
};
AtpReallocationTable.displayName = 'AtpReallocationTable';

export default AtpReallocationTable;
